import React from 'react';
import { Carousel } from 'react-bootstrap';
import { range } from 'lodash';
import { useLocation } from 'react-router-dom';

const CompetitionSidebar = () => {
  const { pathname } = useLocation();
  const isVertex = pathname.toLowerCase().includes('vertex');

  return (
    <Carousel controls={false}>
      {range(isVertex ? 9 : 8, isVertex ? 10 : 9).map((i) => {
        return (
          <Carousel.Item key={i}>
            <img
              className="d-block w-100"
              style={{ objectPosition: 'center' }}
              src={process.env.PUBLIC_URL + "/assets/images/slider/SliderLeft" + i + ".png"}
              alt=""
            />
          </Carousel.Item>
        )
      })}
    </Carousel>
  )
}

export default CompetitionSidebar;